import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { getUserConnect } from 'store/globalState/reducers/userConnections';
import { getInvitations, fetchUserChats, addNewChat } from 'modules/chats';
import ChatList from '../components';

function mapStateToProps(state) {
  return {
    userChats: state.chats.chats,
    literals: state.i18n.literals.chat || {},
    app: state.app,
    userConnections: state.userConnections.connections,
    user: state.session.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getInvitations: bindActionCreators(getInvitations, dispatch),
    fetchChats: bindActionCreators(fetchUserChats, dispatch),
    fetchUserConnections: bindActionCreators(getUserConnect, dispatch),
    addNewChat: bindActionCreators(addNewChat, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChatList));



// WEBPACK FOOTER //
// ./src/components/Chats/container/index.js